import { Contractor, StarterInfo } from '../types';
import axios from 'axios';
import config from '../../config';

export const postContractorToDocumentDb = (
    signatureId: string,
    starterInfo: StarterInfo,
    {
        companyInfo,
        documents,
        serviceArea,
        teamInfo,
        trades,
        registerForLaborJobs,
        partsEquipmentOrdering,
    }: Contractor,
    uuid: string
) => {
    const { forMyCompany, onBehalfOfClient, neither, clients } =
        partsEquipmentOrdering;

    return axios.post(`${config.apiBaseUrl}/Contractors/registrations`, {
        signatureId,
        ...starterInfo,
        uuid,
        companyInfo,
        documents,
        serviceArea,
        teamInfo,
        trades,
        registerForLaborJobs,
        partsEquipmentOrdering: { forMyCompany, onBehalfOfClient, neither },
        directSupplyClientIds: clients.map(client => client.value),
        status: 'PENDING',
    });
};
